import type { Requests } from "../common/request.common";
import type { RadiusServerResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const radiusServer = {
    record(data: typeof Requests.RadiusServer.Record.Input) {
        return post<typeof data, RadiusServerResponseTypes.Record>(`/radius-server/record`, data);
    },
    obtain(id: string) {
        return get<RadiusServerResponseTypes.Obtain>(`/radius-server/obtain/${id}`);
    },
    delete(id: string) {
        return postEmpty(`/radius-server/delete/${id}`);
    },
};
